export function getEnumKeys(e) {
    const options = [];
    for(const key in e) {
        options.push(key);
    }
    return options;
}

export function getEnumValues(e) {
    const options = [];
    for(const key in e) {
        options.push(e[key]);
    }
    return options;
}